import { styled } from "@mui/system"
import { Paper, Typography } from "@mui/material"
// @ts-ignore
import DownloadIcon from "../../icon/downloadIcon.svg?react"

export const AttachmentBar = styled(Paper)({
  display: "flex",
  padding: "8px 16px",
  alignItems: "center",
  gap: "8px",
})

export const AttachmentText = styled(Typography)({
  flex: "1 0 0",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
})

export const AttachmentIcon = styled(DownloadIcon)({
  width: "24px",
  height: "24px",
})
